import React from 'react'

// On-brand avatar palette (bg, fg) picked deterministically from the name so
// rows get a little life without introducing per-user color data server-side.
const AVATAR_PALETTE = [['#d7e2f8', '#9392ad']]

const hashString = (value) => {
    let hash = 0
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) | 0
    }
    return Math.abs(hash)
}

const Avatar = ({ firstName, lastName, size = 36 }) => {
    const initials = `${(firstName || '')[0] || ''}${(lastName || '')[0] || ''}`.toUpperCase() || '?'
    const [bg, fg] = AVATAR_PALETTE[hashString(`${firstName} ${lastName}`) % AVATAR_PALETTE.length]
    return (
        <span className="rounded-full flex items-center justify-center font-bold text-[13px] flex-shrink-0" style={{ background: bg, color: fg, width: size, height: size }}>
            {initials}
        </span>
    )
}

export default Avatar
